module.exports = __webpack_public_path__ + "img/icon-4.63b82207.png";